import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// ar-KW
import alertsAr from './locales/ar-KW/alerts.json'
import apiAr from './locales/ar-KW/api.json'
import bannersAr from './locales/ar-KW/banners.json'
import bottomSheetsAr from './locales/ar-KW/bottomSheets.json'
import commonAr from './locales/ar-KW/common.json'
import currencyAr from './locales/ar-KW/currency.json'
import formAr from './locales/ar-KW/form.json'
import linksAr from './locales/ar-KW/links.json'
import messagesAr from './locales/ar-KW/messages.json'
import screensAr from './locales/ar-KW/screens.json'
import transactionsAr from './locales/ar-KW/transactions.json'
import translationAr from './locales/ar-KW/translation.json'

// en-US
import alertsEn from './locales/en-US/alerts.json'
import apiEn from './locales/en-US/api.json'
import bannersEn from './locales/en-US/banners.json'
import bottomSheetsEn from './locales/en-US/bottomSheets.json'
import commonEn from './locales/en-US/common.json'
import currencyEn from './locales/en-US/currency.json'
import formEn from './locales/en-US/form.json'
import linksEn from './locales/en-US/links.json'
import messagesEn from './locales/en-US/messages.json'
import screensEn from './locales/en-US/screens.json'
import transactionsEn from './locales/en-US/transactions.json'
import translationEn from './locales/en-US/translation.json'

// pt-BR
import alertsPt from './locales/pt-BR/alerts.json'
import apiPt from './locales/pt-BR/api.json'
import bannersPt from './locales/pt-BR/banners.json'
import bottomSheetsPt from './locales/pt-BR/bottomSheets.json'
import commonPt from './locales/pt-BR/common.json'
import currencyPt from './locales/pt-BR/currency.json'
import formPt from './locales/pt-BR/form.json'
import linksPt from './locales/pt-BR/links.json'
import messagesPt from './locales/pt-BR/messages.json'
import screensPt from './locales/pt-BR/screens.json'
import transactionsPt from './locales/pt-BR/transactions.json'
import translationPt from './locales/pt-BR/translation.json'

export const NSKeysList = [
  'common',
  'translation',
  'form',
  'messages',
  'transactions',
  'api',
  'screens',
  'currency',
  'bottomSheets',
  'links',
  'alerts',
  'banners',
]

const resources = {
  'ar-KW': {
    common: commonAr,
    translation: translationAr,
    api: apiAr,
    form: formAr,
    messages: messagesAr,
    transactions: transactionsAr,
    screens: screensAr,
    currency: currencyAr,
    bottomSheets: bottomSheetsAr,
    links: linksAr,
    alerts: alertsAr,
    banners: bannersAr,
  },
  'en-US': {
    common: commonEn,
    translation: translationEn,
    api: apiEn,
    form: formEn,
    messages: messagesEn,
    transactions: transactionsEn,
    screens: screensEn,
    currency: currencyEn,
    bottomSheets: bottomSheetsEn,
    links: linksEn,
    alerts: alertsEn,
    banners: bannersEn,
  },
  'pt-BR': {
    common: commonPt,
    translation: translationPt,
    api: apiPt,
    form: formPt,
    messages: messagesPt,
    transactions: transactionsPt,
    screens: screensPt,
    currency: currencyPt,
    bottomSheets: bottomSheetsPt,
    links: linksPt,
    alerts: alertsPt,
    banners: bannersPt,
  },
}

i18n.use(initReactI18next).init({
  resources,
  lng: undefined,
  fallbackLng: 'en-US',
  ns: NSKeysList,
  defaultNS: 'translation',
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
})

export default i18n
